import { createFileRoute } from '@tanstack/react-router';
import { ReformaPage } from '@/components/reforma/reforma-page';

export const Route = createFileRoute('/_app/configuracoes/reforma')({
  component: ReformaRota,
});

function ReformaRota() {
  return <ReformaPage />;
}
